/**
 * Beépített háttérképek: az src/assets/backgrounds mappába tett képek automatikusan
 * bekerülnek (jpg/webp/png). Ha a szervezetnek van saját háttere, az elsőbbséget élvez.
 */
const bundled = Object.values(
  import.meta.glob("../assets/backgrounds/*.{jpg,jpeg,webp,png}", { eager: true, query: "?url", import: "default" }),
) as string[];

export function pickBackground(orgUrls: string[] | undefined, seed = Math.random()): string | null {
  const pool = orgUrls && orgUrls.length ? orgUrls : bundled;
  if (!pool.length) return null;
  return pool[Math.floor(seed * pool.length) % pool.length];
}
